import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ProductDelete } from '../../services';
import { ToastResponse } from '../../utilities/ToastResponse';

export const fetchProductDelete = createAsyncThunk(
    'productGet/fetchProductDelete',
    async ({ id }) => {
        const response = await ProductDelete(id)
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
);

const productDeleteSlice = createSlice({
    name: 'productDelete',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchProductDelete.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchProductDelete.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchProductDelete.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default productDeleteSlice.reducer;
